import * as actionTypes from '../actions/actionTypes';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  alerts: []
};

const alertReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.ALERT_ADD: {
      const matchedAlerts = state.alerts.filter((alert) => {
        return alert.key === action.alert.key;
      });

      if (matchedAlerts < 1) {
        let alerts = state.alerts.concat(action.alert);

        return updateState(state, { alerts: alerts });
      } else {
        return state;
      }
    }
    default: {
      return state;
    }
  }
};

export default alertReducer;